'use strict';

var getProductAvailabilityLabel = require('../../../../../../../../_virtual/getProductAvailabilityLabel.cjs');
var index = require('../../../../node_modules/@fortawesome/pro-regular-svg-icons/index.cjs');
var availabilityStatus = require('../types/availabilityStatus.cjs');

var hasRequiredGetProductAvailabilityLabel;

function requireGetProductAvailabilityLabel () {
	if (hasRequiredGetProductAvailabilityLabel) return getProductAvailabilityLabel.__exports;
	hasRequiredGetProductAvailabilityLabel = 1;

	var index$1 = index.__require();
	var availabilityStatus$1 = availabilityStatus.__require();

	/**
	 * Returns the availability label text based on the availability status.
	 */ const getProductAvailabilityLabel$1 = (availabilityStatus$1$1)=>{
	    let availabilityLabelText = "";
	    let availabilityStatusIcon;
	    switch(availabilityStatus$1$1){
	        case availabilityStatus$1.AvailabilityStatus.BACKORDERED:
	            availabilityLabelText = "Backordered";
	            availabilityStatusIcon = index$1.faClock;
	            break;
	        case availabilityStatus$1.AvailabilityStatus.DISCONTINUED:
	            availabilityLabelText = "Discontinued";
	            availabilityStatusIcon = index$1.faBan;
	            break;
	        case availabilityStatus$1.AvailabilityStatus.TO_BE_DISCONTINUED:
	            availabilityLabelText = "To be discontinued";
	            availabilityStatusIcon = index$1.faBan;
	            break;
	        case availabilityStatus$1.AvailabilityStatus.UNAVAILABLE:
	        case availabilityStatus$1.AvailabilityStatus.NA:
	            availabilityLabelText = "Out of stock";
	            availabilityStatusIcon = index$1.faExclamationCircle;
	            break;
	        case availabilityStatus$1.AvailabilityStatus.FULLY_RESTRICTED:
	            availabilityLabelText = "Restricted";
	            availabilityStatusIcon = index$1.faExclamationCircle;
	            break;
	        default:
	            availabilityLabelText = "";
	    }
	    return {
	        availabilityLabelText,
	        availabilityStatusIcon
	    };
	};

	getProductAvailabilityLabel.__exports.getProductAvailabilityLabel = getProductAvailabilityLabel$1;
	
	return getProductAvailabilityLabel.__exports;
}

exports.__require = requireGetProductAvailabilityLabel;
//# sourceMappingURL=getProductAvailabilityLabel.cjs.map
